/* @flow */

import * as F from 'lodash/fp';

import {
  type Crust,
  Crusts,
  type Sauce,
  Sauces,
  type Topping,
  Toppings,
  ingredientIcon,
} from '../../../pizza/fields/domain/pizza';
import type { SelectOption } from '../../../pizza/fields/ProcPizzaSelect';
import { ingredientName } from '../constants';

const crustOptions: SelectOption<Crust>[] = F.map(
  crust => ({
    value: crust,
    label: ingredientName(crust),
    image: ingredientIcon(crust),
  }),
  Crusts
);

const sauceOptions: SelectOption<Sauce>[] = F.map(
  value => ({
    value,
    label: ingredientName(value),
    image: ingredientIcon(value),
  }),
  Sauces
);

const toppingOptions: SelectOption<Topping>[] = F.map(
  value => ({
    value,
    label: ingredientName(value),
    image: ingredientIcon(value),
  }),
  Toppings
);

export { crustOptions, sauceOptions, toppingOptions };
